import request from '@/utils/request'

// 账号密码登录方法
export function pwdLogin(username, password, code, uuid ) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

// 发送短信验证码方法
export function sendSms(mobile) {
  const data = {
    mobile
  }
  return request({
    url: '/api/v1/mp/sms/sendSmsCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}
